export const version = 'berater-v1.15.0-rc2';